import * as api from "../constants/api";
import * as axiosUtils from "../utils/axiosUtils";

export const actionType = "OVERTREDELSESKODER_MILJOGEBYR";
const metaData = {
  entitet: "Overtredelsekode",
  notify: true,
};
export function getOvertredelseskoderMiljogebyr() {
  return axiosUtils.GetAllWithParams(
    api.GET_OVERTREDELSESKODER_MILJOGEBYR_URL,
    {
      IncludeDeaktivert: true,
    },
    actionType,
  );
}

export function postOvertredelseskoderMiljogebyr(payload) {
  return axiosUtils.Post(
    api.POST_OVERTREDELSESKODER_MILJOGEBYR_URL,
    payload,
    actionType,
    metaData,
  );
}
export function putOvertredelseskoderMiljogebyr(id, payload) {
  return axiosUtils.Put(
    api.PUT_OVERTREDELSESKODER_MILJOGEBYR_URL(id),
    payload,
    actionType,
    metaData,
  );
}
